module.exports = __webpack_public_path__ + "img/bracket-bg-1.b9a5b7ae.png";